import styled from 'styled-components';

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  @media (max-width: 991px) {
    grid-template-columns: auto auto auto;
  }
  @media (max-width: 767px) {
    grid-template-columns: auto auto auto auto;
  }
  @media (max-width: 576px) {
    grid-template-columns: auto auto auto;
  }
`;

const TileContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Overlay = styled.div`
  position: absolute;
  cursor: pointer;
  background: rgb(10, 10, 10);
  height: 100%;
  width: 100%;
  opacity: 0.6;
  &:hover {
    opacity: 0.8;
    background: var(--darkest);
  }
`;

const TextContainer = styled.div`
  pointer-events: none;
  position: absolute;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    margin: 0 !important;
    color: white;

    @media (max-width: 575px) {
      font-size: var(--font-size-p-sm) !important;
    }
  }
`;

export { GridContainer, TileContainer, Overlay, TextContainer };
